import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IMainState } from '../../../../store/states'
import { UserBox, UserBoxItem } from '../../../../design-system/navbar'
import { cookiesKiller, getLoginUri } from '../../../../helpers/cookies.helper'

const UserData: React.FC = () => {
  const { user } = useSelector(({ user }: IMainState) => user)
  const { t } = useTranslation()
  const { name, avatar } = user

  return (
    <UserBox name={name} srcAvatar={avatar}>
      <UserBoxItem
        title={t('commons.navBar.closeSession')}
        href={getLoginUri()}
        action={() => cookiesKiller('rankmi_jwt')}
      />
    </UserBox>
  )
}

export default UserData
